import { call, put, all, takeEvery, select } from "redux-saga/effects";
import api from "../services/risks.service";
import { risksActions, generalActions } from "../actions";
import ACTIONS from "../constants";
import { riskPagination } from "../selectors/risks.selector";

function* getRisk(state) {
  try {
    yield put(risksActions.getRiskAttempt.pending);
    const risks = yield call(api.riskRequest, state.payload);
    const pagination = JSON.parse(risks.headers["x-pagination"]);
    const data = {
      data: risks.data,
      pagination: pagination,
    };
    yield put(risksActions.getRiskAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(risksActions.getRiskAttempt.error(""));
    } else {
      yield put(risksActions.getRiskAttempt.error(error.message));
    }
  }
}

function* createRisk(state) {
  try {
    yield put(risksActions.createRiskAttempt.pending);
    yield call(api.createRiskRequest, state.payload);
    // const paginat = yield select(riskPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    // const payload = {id: state.payload.id, page: paginat.CurrentPage, size: paginat.PageSize}
    const risks = yield call(api.riskRequest, payload);
    const pagination = JSON.parse(risks.headers["x-pagination"]);
    const data = {
      data: risks.data,
      pagination: pagination,
    };
    yield put(risksActions.createRiskAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Risk Item created successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(risksActions.createRiskAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(risksActions.createRiskAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(risksActions.createRiskAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateRisk(state) {
  try {
    yield put(risksActions.updateRiskAttempt.pending);
    yield call(api.updateRiskRequest, state.payload.payload);
    const paginat = yield select(riskPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    // const payload = {id:state.payload.id, page: paginat.CurrentPage, size: paginat.PageSize}
    const risk = yield call(api.riskRequest, payload);
    const pagination = JSON.parse(risk.headers["x-pagination"]);
    const data = {
      data: risk.data,
      pagination: pagination,
    };
    yield put(risksActions.updateRiskAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Risk updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(risksActions.updateRiskAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(risksActions.updateRiskAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(risksActions.updateRiskAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteRisk(state) {
  try {
    yield put(risksActions.deleteRiskAttempt.pending);
    yield call(api.deleteRiskRequest, { id: state.payload.sId });
    const paginat = yield select(riskPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    // const payload = {id:state.payload.id, page: paginat.CurrentPage, size: paginat.PageSize}
    const risk = yield call(api.riskRequest, payload);
    const pagination = JSON.parse(risk.headers["x-pagination"]);
    const data = {
      data: risk.data,
      pagination: pagination,
    };
    yield put(risksActions.deleteRiskAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(risksActions.deleteRiskAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(risksActions.deleteRiskAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(risksActions.deleteRiskAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* sortRisks(state) {
  try {
    yield put(risksActions.sortRiskAttempt.pending);
    const risks = yield call(api.sortRiskRequest, state.payload);
    const pagination = JSON.parse(risks.headers["x-pagination"]);
    const data = {
      data: risks.data,
      pagination: pagination,
    };
    yield put(risksActions.sortRiskAttempt.success(data));
  } catch (error) {
    yield put(risksActions.sortRiskAttempt.error(error));
  }
}

function* updateRiskFlag(state) {
  try {
    yield put(risksActions.updateRiskFlagAttempt.pending);
    yield call(api.updateRiskFlagRequest, state.payload);
    yield put(risksActions.updateRiskFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Risk flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(risksActions.updateRiskFlagAttempt.error(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.RISK_CALL, getRisk),
    takeEvery(ACTIONS.CREATE_RISK_CALL, createRisk),
    takeEvery(ACTIONS.UPDATE_RISK_CALL, updateRisk),
    takeEvery(ACTIONS.DELETE_RISK_CALL, deleteRisk),
    takeEvery(ACTIONS.SORT_RISKS_CALL, sortRisks),
    takeEvery(ACTIONS.RISK_FLAG_CALL, updateRiskFlag),
  ]);
}
